@if (risk(); as riskData) {
  @if (showHeader()) {
    <h5 class="font-weight-bold">
      @if (riskData.comply_entity_type === 'person') {
        <i class="fa fa-user"></i>
      }
      @if (riskData.comply_entity_type === 'company') {
        <i class="fa fa-building"></i>
      }
      <span
        [innerHTML]="
          riskData.match_name | highlightText: highlightTexts() : 'highlightText highlightText-yellow'
        "></span>
    </h5>
  }
  <p>
    <span class="text-muted">{{ 'screening.case.review.supplier.match_name' | translate }}: </span>
    <span
      [innerHTML]="riskData.match_name | highlightText: highlightTexts() : 'highlightText highlightText-yellow'"></span>
  </p>
  <p>
    <span class="text-muted">{{ 'screening.case.review.supplier.match_score' | translate }}: </span>
    {{ riskData.match_score | number: '1.1-2' }}
  </p>
  @if (riskData.comply_entity_type !== 'person' && riskData.comply_entity_type !== 'company') {
    <p>
      <span class="text-muted">{{ 'screening.case.review.supplier.entity_type' | translate }}: </span>
      {{ riskData.comply_entity_type }}
    </p>
  }
  @if (riskData.amlTypes.length > 0) {
    <p>
      <span class="text-muted">{{ 'screening.case.review.supplier.aml_types' | translate }}: </span>
      @for (amlType of riskData.amlTypes; track amlType) {
        <span class="badge ms-1" [class]="getAmlTypeBadgeClass(amlType)">{{ amlType }}</span>
      }
    </p>
  }
  @if (riskData.datesOfBirth.length > 0) {
    <p>
      <span class="text-muted">{{ 'screening.case.review.supplier.date_of_birth' | translate }}: </span>
      @for (dob of riskData.datesOfBirth; track dob.value) {
        <span class="ms-1">{{ parseDate(dob.value) | date }}</span>
        @if (dob.source) {
          <small class="text-muted ms-1">({{ dob.source }})</small>
        }
      }
    </p>
  }
  @if (riskData.peps.length > 0) {
    <p class="mb-0">
      <span class="text-muted">{{ 'screening.case.review.supplier.pep_information' | translate }}: </span>
    </p>
    @for (pep of riskData.peps; track $index) {
      <div class="ms-3 mt-2 mb-3 p-3 bg-light rounded">
        @if (pep.name) {
          <p>
            <span class="text-muted">{{ 'screening.case.review.supplier.source' | translate }}: </span> {{ pep.name }}
          </p>
        }
        @if (pep.political_positions && pep.political_positions.length > 0) {
          <p>
            <span class="text-muted">{{ 'screening.case.review.supplier.political_positions' | translate }}: </span>
            @for (position of pep.political_positions; track position) {
              <span class="badge bg-info ms-1">{{ position }}</span>
            }
          </p>
        }
        @if (pep.country_codes && pep.country_codes.length > 0) {
          <p>
            <span class="text-muted">{{ 'screening.case.review.supplier.countries' | translate }}: </span>
            @for (countryCode of pep.country_codes; track countryCode) {
              <span class="flag flag-{{ countryCode | lowercase }} ms-1"></span>
            }
          </p>
        }
        @if (pep.political_parties && pep.political_parties.length > 0) {
          <p>
            <span class="text-muted">{{ 'screening.case.review.supplier.political_parties' | translate }}: </span>
            @for (party of pep.political_parties; track party) {
              <span class="ms-1">{{ party }}</span>
            }
          </p>
        }
        @if (pep.url) {
          <p>
            <span class="text-muted">{{ 'screening.case.review.supplier.url' | translate }}: </span>
            <a [href]="pep.url" target="_blank" rel="noopener noreferrer" class="text-break">{{ pep.url }}</a>
          </p>
        }
        @if (pep.listing_ended_utc || pep.listing_started_utc) {
          <p>
            <span class="text-muted">{{ 'screening.case.review.supplier.active_period' | translate }}: </span>
            @if (pep.listing_started_utc) {
              <span
                >{{ 'screening.case.review.supplier.from' | translate }}
                {{ parseDate(pep.listing_started_utc) | date }}</span
              >
            }
            @if (pep.listing_ended_utc) {
              <span
                >{{ 'screening.case.review.supplier.until' | translate }}
                {{ parseDate(pep.listing_ended_utc) | date }}</span
              >
            }
          </p>
        }
        @if (pep.fields && pep.fields.length > 0) {
          <section class="mt-2">
            <span class="text-muted">{{ 'screening.case.review.supplier.additional_fields' | translate }}: </span>
            <ul class="pretty-list ms-0 mt-1">
              @for (field of pep.fields || []; track $index) {
                @if (
                  field?.tag === 'political_position' ||
                  field?.tag === 'date_of_birth' ||
                  field?.name === 'Political Position' ||
                  field?.name === 'Date of Birth'
                ) {
                  <li>
                    <span class="me-2">{{ field?.name || field?.tag }}:</span>
                    @if (
                      field?.tag === 'date_of_birth' ||
                      field?.name === 'Date of Birth' ||
                      field?.name === 'Designation Date'
                    ) {
                      {{ parseDate(field?.value) | date }}
                    } @else {
                      {{ field?.value }}
                    }
                  </li>
                }
              }
            </ul>
          </section>
        }
      </div>
    }
  }
  @if (riskData.names.length > 0) {
    <p class="mb-0">
      <span class="text-muted">{{ 'screening.case.review.supplier.known_names' | translate }}: </span>
    </p>
    <div class="mt-2 mb-3 p-3 bg-light rounded">
      @for (nameItem of riskData.names; track nameItem.name; let last = $last) {
        <span
          [innerHTML]="nameItem.name | highlightText: highlightTexts() : 'highlightText highlightText-yellow'"></span
        ><span [hidden]="last">, </span>
      }
    </div>
  }
  @if (riskData.associates.length > 0) {
    <p class="mb-0">
      <span class="text-muted">{{ 'screening.case.review.supplier.associates' | translate }}: </span>
    </p>
    <div class="mt-2 mb-3 p-3 bg-light rounded">
      <ul class="list-unstyled ms-0 mt-1">
        @for (associate of riskData.associates; track associate.name) {
          <li>
            <span class="text-muted">{{ associate.name }}</span>
            @if (associate.type) {
              <span class="text-muted ms-1">({{ associate.type }})</span>
            }
          </li>
        }
      </ul>
    </div>
  }
  @if (riskData.sanctions.length > 0) {
    <p class="mb-0">
      <span class="text-muted">{{ 'screening.case.review.supplier.sanction_information' | translate }}: </span>
    </p>
    @for (sanction of riskData.sanctions; track $index) {
      <div class="mt-2 mb-3 p-3 bg-light rounded">
        @if (sanction.name) {
          <p>
            <span class="text-muted">{{ 'screening.case.review.supplier.source' | translate }}: </span> {{ sanction.name }}
          </p>
        }
        @if (sanction.country_codes && sanction.country_codes.length > 0) {
          <p>
            <span class="text-muted">{{ 'screening.case.review.supplier.countries' | translate }}: </span>
            @for (countryCode of sanction.country_codes; track countryCode) {
              <span class="flag flag-{{ countryCode | lowercase }} ms-1"></span>
            }
          </p>
        }
        @if (sanction.listing_ended_utc || sanction.listing_started_utc) {
          <p>
            <span class="text-muted">{{ 'screening.case.review.supplier.active_period' | translate }}: </span>
            @if (sanction.listing_started_utc) {
              <span
                >{{ 'screening.case.review.supplier.from' | translate }}
                {{ parseDate(sanction.listing_started_utc) | date }}</span
              >
            }
            @if (sanction.listing_ended_utc) {
              <span
                >{{ 'screening.case.review.supplier.until' | translate }}
                {{ parseDate(sanction.listing_ended_utc) | date }}</span
              >
            }
          </p>
        }
        @if (sanction.url) {
          <p>
            <span class="text-muted">{{ 'screening.case.review.supplier.url' | translate }}: </span>
            <a [href]="sanction.url" target="_blank" rel="noopener noreferrer" class="text-break">{{ sanction.url }}</a>
          </p>
        }
        @if (sanction.related_urls && sanction.related_urls.length > 0) {
          <p>
            <span class="text-muted">{{ 'screening.case.review.supplier.related_urls' | translate }}: </span><br />
            @for (relatedUrl of sanction.related_urls; track relatedUrl) {
              <a [href]="relatedUrl" target="_blank" rel="noopener noreferrer" class="text-break">{{ relatedUrl }}</a
              ><br />
            }
          </p>
        }
        @if (sanction.fields && sanction.fields.length > 0) {
          <section class="mt-2">
            @if (getRegularFields(sanction.fields).length > 0) {
              <section class="mb-2">
                <span class="text-muted">{{ 'screening.case.review.supplier.additional_fields' | translate }}: </span>
                <ul class="pretty-list ms-0 mt-1">
                  @for (field of getRegularFields(sanction.fields); track $index) {
                    <li>
                      <span class="me-2">{{ field?.name || field?.tag }}: </span>
                      @if (isDateField(field)) {
                        {{ parseDate(field?.value) | date }}
                      } @else {
                        {{ field?.value }}
                      }
                    </li>
                  }
                </ul>
              </section>
            }
            @if (getPassportFields(sanction.fields).length > 0) {
              <section class="mt-2">
                <span class="text-muted">{{ 'screening.case.review.supplier.passport' | translate }}: </span>
                <ul class="pretty-list ms-0 mt-1">
                  @for (field of getPassportFields(sanction.fields); track $index) {
                    <li>{{ field?.value }}</li>
                  }
                </ul>
              </section>
            }
            @if (getAdditionalSanctionsInfoFields(sanction.fields).length > 0) {
              <section class="mt-2">
                <span class="text-muted">{{ 'screening.case.review.supplier.additional_sanctions_information' | translate }}: </span>
                <ul class="pretty-list ms-0 mt-1">
                  @for (field of getAdditionalSanctionsInfoFields(sanction.fields); track $index) {
                    <li>{{ field?.value }}</li>
                  }
                </ul>
              </section>
            }
          </section>
        }
      </div>
    }
  }
  @if (riskData.lists.length > 0) {
    <p class="mb-0">
      <span class="text-muted">{{ 'screening.case.review.supplier.lists' | translate }}: </span>
    </p>
    <div class="mt-2 mb-3 p-3 bg-light rounded">
      @for (list of riskData.lists; track $index) {
        @if (list.name) {
          <p>
            <span class="text-muted">{{ 'screening.case.review.supplier.source' | translate }}: </span> {{ list.name }}
          </p>
        }
        @if (list.country_codes && list.country_codes.length > 0) {
          <p>
            <span class="text-muted">{{ 'screening.case.review.supplier.countries' | translate }}: </span>
            @for (countryCode of list.country_codes; track countryCode) {
              <span class="flag flag-{{ countryCode | lowercase }} ms-1"></span>
            }
          </p>
        }
        @if (list.aml_types && list.aml_types.length > 0) {
          <p>
            <span class="text-muted">{{ 'screening.case.review.supplier.aml_types' | translate }}: </span>
            @for (amlType of list.aml_types; track amlType) {
              <span class="badge ms-1" [class]="getAmlTypeBadgeClass(amlType)">{{ amlType }}</span>
            }
          </p>
        }
        @if (list.fields && list.fields.length > 0) {
          <section class="mt-2">
            <span class="text-muted">{{ 'screening.case.review.supplier.additional_fields' | translate }}: </span>

            <ul class="pretty-list ms-0 mt-1 mb-0">
              @for (field of list.fields || []; track $index) {
                <li>
                  <span class="me-2">{{ field?.name || field?.tag }}: </span> {{ field?.value }}
                </li>
              }
            </ul>
          </section>
        }
      }
    </div>
  }
  @if (riskData.media.length > 0) {
    <p class="mb-0">
      <span class="text-muted">{{ 'screening.case.review.supplier.media' | translate }}: </span>
    </p>
    <div class="mt-2 p-3 bg-light rounded">
      @for (mediaItem of riskData.media; track $index) {
        <article class="mb-2">
          @if (mediaItem.title) {
            <h4>
              @if (mediaItem.url) {
                <a [href]="mediaItem.url" target="_blank" rel="noopener noreferrer" class="text-break">{{
                  mediaItem.title
                }}</a>
              } @else {
                {{ mediaItem.title }}
              }
            </h4>
          }
          @if (mediaItem.snippet) {
            <p>
              <span class="text-muted">{{ 'screening.case.review.supplier.snippet' | translate }}: </span>
              {{ mediaItem.snippet }}
            </p>
          }
          @if (mediaItem.publishing_date) {
            <p>
              <span class="text-muted">{{ 'screening.case.review.supplier.publishing_date' | translate }}: </span>
              {{ parseDate(mediaItem.publishing_date) | date }}
            </p>
          }
          @if (mediaItem.url && !mediaItem.title) {
            <p>
              <span class="text-muted">{{ 'screening.case.review.supplier.url' | translate }}: </span>
              <a [href]="mediaItem.url" target="_blank" rel="noopener noreferrer" class="text-break">{{
                mediaItem.url
              }}</a>
            </p>
          }
        </article>
        <hr />
      }
    </div>
  }
}
